import { Link } from "react-router-dom";
import { SiteFooter } from "../components/SiteFooter";

export function Privacy() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="px-6 py-4 flex items-center justify-between border-b border-bg-2">
        <Link to="/" className="font-semibold tracking-tight">
          MCPBuild
        </Link>
        <Link to="/" className="text-sm text-fg-1 hover:text-fg-0">
          ← Home
        </Link>
      </header>

      <main className="flex-1 max-w-3xl mx-auto px-6 py-10 space-y-6 text-fg-1 leading-relaxed">
        <h1 className="text-3xl font-semibold text-fg-0">Privacy</h1>
        <p className="text-xs text-fg-2">Last updated: 2026-05-21 · MCPBuild is in Beta</p>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-fg-0">What we collect</h2>
          <ul className="list-disc list-inside space-y-1 text-sm">
            <li>
              <strong>Your email address</strong> — used to send magic-link sign-in
              emails and as your account identifier.
            </li>
            <li>
              <strong>Widget source code + data</strong> — the React TSX and the
              structured data your connected LLM passes to the{" "}
              <code className="font-mono">dynamic_widget</code> and{" "}
              <code className="font-mono">save_widget_to_app</code> tools. Stored
              so you can preview, edit, and re-render later.
            </li>
            <li>
              <strong>Project metadata</strong> — the names, slugs, and icons
              you create for grouping saved widgets.
            </li>
            <li>
              <strong>Standard server logs</strong> — IP, request times, error
              traces (CloudWatch). Retained ~30 days for debugging.
            </li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-fg-0">What we don't do</h2>
          <ul className="list-disc list-inside space-y-1 text-sm">
            <li>We don't share, sell, or rent your data to anyone.</li>
            <li>
              We don't run an LLM on our servers. The widget source is authored
              by <em>your</em> connected LLM (Claude Desktop, ChatGPT, etc.) —
              MCPBuild only validates, bundles, and hosts.
            </li>
            <li>We don't use third-party analytics or tracking.</li>
            <li>
              Paid plans are processed by Stripe — your card details go directly
              to Stripe and never touch our servers.
            </li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-fg-0">Data location + control</h2>
          <p className="text-sm">
            Data is stored in AWS us-east-1 (DynamoDB + S3). Inbox widgets
            auto-delete after 24 hours via DynamoDB TTL. Saved widgets stay
            until you delete them or close your account.
          </p>
          <p className="text-sm">
            Want everything deleted? Email{" "}
            <a
              href="mailto:matt.martz@gmail.com"
              className="text-accent underline"
            >
              matt.martz@gmail.com
            </a>{" "}
            from the address you signed up with — your data will be removed
            within a few days.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-fg-0">Cookies + storage</h2>
          <p className="text-sm">
            MCPBuild stores your JWT session token in your browser's
            localStorage so you stay signed in. No tracking cookies. Logout
            clears it.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-lg font-semibold text-fg-0">Changes</h2>
          <p className="text-sm">
            This policy may change as the product evolves. Material changes will
            be announced on the landing page. Continuing to use MCPBuild after a
            change means you accept the updated terms.
          </p>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}
